
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import videojs from 'video.js';
import 'video.js/dist/video-js.css';

@Component({
  components: {}
})
export default class VideoPlayer extends Vue {
  @Prop() source: any;
  player: any = null;
  reseted: boolean = true;
  get playerOptions() {
    return {
      // videojs options
      // autoplay: true,
      controls: true,
      controlBar: {
        children: [
          'playToggle',
          'volumeMenuButton',
          'durationDisplay',
          'timeDivider',
          'currentTimeDisplay',
          'progressControl',
          'remainingTimeDisplay',
          'fullscreenToggle'
        ]
      },
      // muted: true,
      // autoplay: true,
      // language: "en",
      height: '400px',
      playbackRates: [0.7, 1.0, 1.5, 2.0],
      sources: [
        {
          type: 'video/mp4',
          src: this.source.videoUrl || ''
        }
      ],
      poster: this.source.imgUrl || ''
    };
  }

  mounted() {
    this.player = videojs(
      this.$refs.videoPlayer,
      this.playerOptions,
      function onPlayerReady() {
      }
    );
  }
  beforeDestroy() {
    if (this.player) {
      this.player.dispose();
    }
  }

  @Watch('source', { immediate: true, deep: true })
  changeVideo(source: any) {
    if (this.player && this.player.dispose) {
      this.player && this.player.pause && this.player.pause();
      this.player.dispose();
      this.$nextTick(() => {
        this.reseted = false;
        this.$nextTick(() => {
          this.reseted = true;
          this.$nextTick(() => {
            this.player = null;
            this.player = videojs(
              this.$refs.videoPlayer,
              this.playerOptions,
              function onPlayerReady() {
                //
              }
            );
          });
        });
      });
    }
  }
}
